<template>
  <div id="box" @click="gotoPrize" v-if="!easyUser && active && enableLottery">
    <img src="//res.uuudian.com/hk_data/d64c09e8-389a-42c9-afea-b7cbf8ace109" alt />
    <span class="red" v-if="showRedDot"></span>
  </div>
</template>

<script>
import $ from "jquery";
import store from "../../api/store";
import api from '../../api'


export default {
  props:["showRedDot"],
  data() {
    return {
      easyUser: store.loginedUser.easyUser,
      active:true,
      enableLottery:store.loginedUser.enableLottery
    };
  },

  created(){
    console.log(api);
    this.getActice()
  },
  methods: {
    gotoPrize() {
      var url = process.env.lotteryLoginUrl;
      location.href = url;
    },

    getActice(){
       api.lottery.getLotteryActive(data=>{
         store.active = data.active
         this.active = data.active
       })
    }
  }
};

var stopBodyMove = e => {
  e.preventDefault();
};

var touchStart_x = null,
  touchStart_y = null,
  touchMove_x = null,
  touchMove_y = null,
  box_x = null,
  box_y = null;
$("body").on("touchstart", "#box", function(e) {
  if (touchStart_x === null) {
    touchStart_x = e.targetTouches[0].pageX; // 鼠标按下的位置 X
    touchStart_y = e.targetTouches[0].pageY; // 鼠标按下的位置 y
  }

  document.body.addEventListener("touchmove", stopBodyMove, { passive: false });
});

$("body").on("touchmove", "#box", function(e) {
  $("#box").removeClass("not-click");

  if (!document.querySelector("#box").contains(e.target)) {
    e.preventDefault();
  }

  console.log(e.targetTouches[0].pageY);

  touchMove_x = e.targetTouches[0].pageX - touchStart_x;
  touchMove_y = e.targetTouches[0].pageY - touchStart_y - window.pageYOffset;

  $("#box").css({
    transform: `translate3d(${touchMove_x}px, ${touchMove_y}px, 0px)`
  });
});

var animationTimer = null;

$("body").on("touchend", "#box", function(e) {
  document.body.removeEventListener("touchmove", stopBodyMove);

  clearTimeout(animationTimer);

  animationTimer = setTimeout(() => {
    var top = document.getElementById("box").getBoundingClientRect().top;

    var padRight = function() {
      $("#box")
        .addClass("animate")
        .css({
          transform: `translate3d(20px, ${touchMove_y}px, 0px)`
        });

      setTimeout(() => {
        $("#box").removeClass("animate");
      }, 300);
    };

    padRight();

    $("#box").addClass("not-click");
  }, 1000);
});

$("body").on("touchmove", "#box-mask", function(e) {
  e.preventDefault();
  e.stopPropagation();
});
</script>

<style lang="less" scoped>
#box {
  position: fixed;
  top: 50%;
  right: 10px;
  z-index: 999;
  img {
    width: 51px;
    height: 51px;
  }
  &.animate {
    transition: 0.3s all ease;
  }
  .red {
    width: 7px;
    height: 7px;
    background: #ff0000;
    display: inline-block;
    position: absolute;
    top: 0;
    right: -3px;
    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Box.vue